module.exports = __webpack_public_path__ + "c6b33fe0e3ebc389938eb6b781afd457.jpg";